export default __webpack_public_path__ + "static/media/backBlack.f0ae9d8e.svg";